const currencySigns: Record<string, string> = {
    RUB: "₽",
    UAH: "₴",
    MXN: "MX$",
    JPY: "¥",
    ILS: "₪",
    AUD: "AU$",
    GBP: "£",
    EUR: "€",
    USD: "$",
};

export const getCurrencySign = (currency: string): string => currencySigns?.[currency] ?? currencySigns.USD;
